/**
 * @generated SignedSource<<c44edef5fc6e65cd9a3a21ad16e8ef4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TemplateStatusEnum = "A" | "R" | "S" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AlimTalkTemplateStatusLabel_alimTalkTemplate$data = {
  readonly isBlock: boolean;
  readonly isDormant: boolean;
  readonly templateStatus: TemplateStatusEnum;
  readonly " $fragmentType": "AlimTalkTemplateStatusLabel_alimTalkTemplate";
};
export type AlimTalkTemplateStatusLabel_alimTalkTemplate$key = {
  readonly " $data"?: AlimTalkTemplateStatusLabel_alimTalkTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"AlimTalkTemplateStatusLabel_alimTalkTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AlimTalkTemplateStatusLabel_alimTalkTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isBlock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDormant",
      "storageKey": null
    }
  ],
  "type": "AlimTalkTemplate",
  "abstractKey": null
};

(node as any).hash = "4e13cd3e51eda4c870a1f672a4a30db0";

export default node;
